import { IOption } from "Dashboard/domain/IOption";
import { forwardRef, useEffect, useState } from "react";
import Select from "react-select";
import { resourceCategoryDictionary } from "utils/translationDictionary";
import { resourcesServices } from "../services/resource.service";

const CategorySelect = forwardRef<any, any>((props, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState<IOption[]>([]);
  const [value, setValue] = useState<IOption | null>(null);

  useEffect(() => {
    async function getData() {
      const categories = await resourcesServices.getResourcesCategories();
      const op = categories.map((category) => {
        return {
          label: resourceCategoryDictionary[category.name],
          value: category.categoryId,
        };
      });
      setOptions(op);
      setIsLoading(false);
    }

    try {
      getData();
    } catch (err) {
      console.log(err);
    }
  }, []);

  const getValue = () => {
    if (props.value) {
      const values = options.filter((o) => o.value === props.value);
      if (values[0]) {
        return values[0];
      }
    }
    return value;
  };

  const handleChange = (newValue: IOption | null, actionMeta: any) => {
    setValue(newValue);
    props.onChange && props.onChange(newValue ? newValue.value : null);
  };

  return (
    <Select
      styles={props.customStyles}
      menuPosition="fixed"
      isClearable
      ref={ref}
      options={options}
      value={getValue()}
      onChange={handleChange}
      placeholder={""}
      noOptionsMessage={() => "Ne postoji"}
      loadingMessage={() => "Učitavanje..."}
      isLoading={isLoading}
      {...{ error: props.error }}
    />
  );
});

export default CategorySelect;
